module.exports = __webpack_public_path__ + "static/media/img-11.1a5c884b.jpg";